import React, { useContext } from "react";
import { DownloadContext } from "../../../context/DownloadContextProvider";
import "../Partner/Partner.css"; // Importing Partner CSS
import ReactGA from "react-ga4";
import { GENEREATE_LINK } from "../../../Constants";

function InsuranceRenewal() {
  const { handleScroll } = useContext(DownloadContext);

  const handleDownloadApp = () =>{
    
    ReactGA.gtag("event", "hp_services_clicked", {
      event_category: "button", 
      event_label: "Home_Page_UI",
      value: 1,
      service: "insurance",
      button : "download_app"
    });
    window.location.href = GENEREATE_LINK;
    
  }

  return (
    <div className="Partner_MainDiv">
      {/* Partner Text Section */}
      <div className="Partner_TextDiv">
        <h2 className="Partner_Heading_text" style={{ lineHeight: "150%" }}>
          Car Insurance Renewals with Benefits
        </h2>

        <div className="Partner_content_text" style={{ marginTop: "1rem" }}>
          Your insurance renewals will never be the same again. Reap immediate
          benefits on your motor insurance renewals with DriveU benefits with
          rewards worth up to ₹2,000.
        </div>

        {/* Button to trigger handleScroll */}
        <div onClick={handleScroll}>
          <button className="Partner_bookNow Book_Now_partner">
            Download App
          </button>
        </div>

        {/* Anchor tag to download the app */}
 
        <button className="Partner_bookNowMobile Book_Now_partner" onClick={handleDownloadApp}>
          Download App
        </button>
      </div>

      {/* Roadside Assistance Image */}
      <div className="Roadside_Assistance_Div">
        <img
          src="https://ik.imagekit.io/driveu/Insurance_EWLEjlfpD.png?ik-sdk-version=javascript-1.4.3&updatedAt=1675677701033"
          alt="door_step_wash"
          loading="lazy"
          className="RoadSideAssistence_Image"
        />
      </div>
    </div>
  );
}

export default InsuranceRenewal;
